module.exports = __webpack_public_path__ + "img/icone_configuracoes_branco.338d1442.svg";